import script from "./PaymentSelectOption.vue?vue&type=script&lang=ts&setup=true"
export * from "./PaymentSelectOption.vue?vue&type=script&lang=ts&setup=true"

import "./PaymentSelectOption.vue?vue&type=style&index=0&id=ac8e0a24&lang=scss"

const __exports__ = script;

export default __exports__